import Logo from "./Logo";
import { ASSETS, APP_STORE_URL, GOOGLE_PLAY_URL } from "./data";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="border-t border-slate-200 bg-[#F6F7FB]">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          <div className="md:col-span-2">
            <Logo markClass="h-7 w-auto" textClass="text-2xl" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-500">
              eurikaa by Parallel Zero, revolutionizing how people connect with places, turning
              every shared experience into a discoverable destination.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-[#0A0E2E]">Get the App</h3>
            <div className="mt-4 flex flex-row flex-wrap items-center gap-3">
              <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-appstore" className="transition-transform hover:scale-[1.03]">
                <img src={ASSETS.appStore} alt="Download on the App Store" className="h-11 w-auto" />
              </a>
              <a href={GOOGLE_PLAY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-googleplay" className="transition-transform hover:scale-[1.03]">
                <img src={ASSETS.googlePlay} alt="Get it on Google Play" className="h-11 w-auto" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center gap-3 border-t border-slate-200 pt-8 text-xs text-slate-400 sm:flex-row sm:flex-wrap sm:gap-0">
          <span>&copy; {year} Parallel Zero. All rights reserved.</span>
          <span className="mx-3 hidden text-slate-300 sm:inline">|</span>
          <a href="/privacy-policy.html" className="transition-colors hover:text-indigo-600">
            Privacy Policy
          </a>
          <span className="mx-3 text-slate-300">|</span>
          <a href="/terms-of-service.html" className="transition-colors hover:text-indigo-600">
            Terms of Service
          </a>
          <span className="mx-3 text-slate-300">|</span>
          <a href="/community-guidelines.html" className="transition-colors hover:text-indigo-600">
            Community Guidelines
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
